<template>
  <div class="ingame-popup-wrap">
    <div class="ingame-popup" :class="{ 'active': show }">
      <p class="popup-title">{{ $t('title_purchase_complete') }}</p>
      <p class="text-box">
        <span>{{ $t('text_purchase_complete') }}</span>
      </p>
      <div class="ingame-popup-bottom">
        <a href="javascript:;" class="btn btn-completed" @click="close">{{ $t('btn_completed') }}</a>
      </div>
      <a href="javascript:;" class="btn-close" @click="close"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseComplete',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.ingame-popup-wrap{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ingame-popup{
  width: 418px;
  min-height: 198px;
  padding: 24px 26px 20px;
  position: relative;
  background: url(~@/assets/img/bg_ingame_popup.png) no-repeat center center;
}
.btn-close{
  width: 28px;
  height: 28px;
  position: absolute;
  top: 5px;
  right: 6px;
  background: url(~@/assets/img/close_ingame_popup.png) no-repeat center center;
  background-size: 18px 18px;
}
.popup-title{
  height: 24px;
  padding-left: 30px;
  margin-bottom: 4px;
  font-size: 20px;
  color: #fff;
  line-height: 24px;
  text-align: left;
  background: url(~@/assets/img/icon_shop.png) no-repeat top left;
  background-size: 24px 24px;
}
.text-box{
  height: 76px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  line-height: 20px;
  color: #DAD9D9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ingame-popup-bottom{
  text-align: center;
  font-size: 0;
}
.btn-completed{
  min-width: 100px;
  height: 36px;
  padding: 0 10px;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  color: #FE6917;
  line-height: 36px;
  border: 1px solid #9D4B1F;
  border-radius: 5px;
  display: inline-block;
}
</style>
